module.exports = __webpack_public_path__ + "static/media/play-player-pass.9a8ab22a.png";